export const Enable = {
    CLOSE: 0,
    OPEN: 1,
};
